import axiosInstance from '@/utils/axiosInstance.js'
import SERVICES from '@/utils/servicesUtil.js'
import Qs from 'qs'

// CREATE and IMPORT AUDIENCE
const hasAudience = organizationId =>
  axiosInstance.get(`${SERVICES.AUDIENCE}/${organizationId}/hasaudience`)
const hasAudienceInProcess = organizationId =>
  axiosInstance.get(`${SERVICES.AUDIENCE}/${organizationId}/hasimportstobeprocessed`)
const sendFile = (organizationId, body) =>
  axiosInstance.post(`${SERVICES.AUDIENCE}/${organizationId}/file`, body, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
const sendTable = (organizationId, body) =>
  axiosInstance.post(`${SERVICES.AUDIENCE}/${organizationId}/manual`, body)
const sendForImport = (organizationId, body) =>
  axiosInstance.post(`${SERVICES.AUDIENCE}/${organizationId}/import`, body)
const getIndicatorsAudience = organizationId =>
  axiosInstance.get(`${SERVICES.AUDIENCE}/${organizationId}/indicators`)

// TYPES
const fieldtypes = organizationId =>
  axiosInstance.get(`${SERVICES.AUDIENCE}/${organizationId}/fieldtypes`)
const patchFieldtypes = (organizationId, body) =>
  axiosInstance.patch(`${SERVICES.AUDIENCE}/${organizationId}/schema`, body)
const defaultFieldDataTypes = () =>
  axiosInstance.get(`${SERVICES.DEFAULT}/defaultusablefielddatatypes`)

// AUDIENCE
//cabeçalho da tabela
const audienceSchema = organizationId =>
  axiosInstance.get(`${SERVICES.AUDIENCE}/${organizationId}/schema`)
const audience = (organizationId, term, Page, Count) =>
  axiosInstance.get(
    `${SERVICES.AUDIENCE}/${organizationId}/recipients?term=${term}&Page=${Page}&Count=${Count}`
  )
const audienceDelete = (organizationId, recipientIds) =>
  axiosInstance.delete(`${SERVICES.AUDIENCE}/${organizationId}/recipients?${recipientIds}`)
const exportAudience = (organizationId, body) =>
  axiosInstance.post(`${SERVICES.AUDIENCE}/${organizationId}/export`, body)
const downloadExport = (organizationId, fileName) =>
  axiosInstance.get(`${SERVICES.AUDIENCE}/${organizationId}/download/${fileName}`, {
    responseType: 'blob'
  })

// HISTORY
const importHistory = organizationId =>
  axiosInstance.get(`${SERVICES.AUDIENCE}/${organizationId}/importshistory`)
const exportHistory = (organizationId, type, importId, body) =>
  axiosInstance({
    url: `${SERVICES.AUDIENCE}/${organizationId}/${type}/${importId}/download`,
    method: 'GET',
    params: body,
    responseType: 'blob'
  })

//SEGMENTS
const getClientSegment = organizationId =>
  axiosInstance.get(`${SERVICES.SEGMENTS}/${organizationId}/filters`)
const getOperators = () => axiosInstance.get(`/audience/api/v1.0/default/defaultoperators`)
const getClientOverview = (organizationId, body) =>
  axiosInstance.post(`${SERVICES.SEGMENTS}/${organizationId}/overview`, body)
const createSegment = (organizationId, body) =>
  axiosInstance.post(`${SERVICES.SEGMENTS}/${organizationId}`, body)
const updateSegment = (organizationId, segmentId, body) =>
  axiosInstance.put(`${SERVICES.SEGMENTS}/${organizationId}/${segmentId}`, body)
const exportSegment = (organizationId, body) =>
  axiosInstance.post(`${SERVICES.SEGMENTS}/${organizationId}/export`, body)
const downloadExportSegment = (organizationId, fileName) =>
  axiosInstance.get(`${SERVICES.SEGMENTS}/${organizationId}/download/${fileName}`, {
    responseType: 'blob'
  })
const getSegment = (organizationId, id) =>
  axiosInstance.get(`${SERVICES.SEGMENTS}/${organizationId}/${id}`)

const getTotalAudience = (organizationId, channel, segments, OverrideUnsubscribedContatcts) =>
  axiosInstance.get(
    `${SERVICES.SEGMENTS}/${organizationId}/audience/total?channel=${channel}&${segments}&OverrideUnsubscribedContatcts=${OverrideUnsubscribedContatcts}`
  )

//SEGMENTS LIST
const getClientSegmentsList = (organizationId, page, count, sortField, sort) => {
  const queryParams = {
    ...(page !== undefined && { Page: page }),
    ...(count !== undefined && { Count: count }),
    ...(sortField && { SortField: sortField }),
    ...(sort && { Sort: sort }),
  };

  return axiosInstance.get(`${SERVICES.SEGMENTS}/${organizationId}`, { params: queryParams });
}
  
const deleteClientSegment = (organizationId, segmentsList) =>
  axiosInstance.delete(`${SERVICES.SEGMENTS}/${organizationId}`, {params: segmentsList, paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: 'repeat' })})

//SEGMENT DETAILS
const getSegmentContactList = (organizationId, body) =>
  axiosInstance.post(`${SERVICES.SEGMENTS}/${organizationId}/overview`, body)

//AUDIENCE DETAIL
const getRecipientId = (organizationId, recipientId) =>
  axiosInstance.get(`${SERVICES.AUDIENCE}/${organizationId}/recipients/${recipientId}`)

const getRecipientEngagement = (organizationId, recipientId) =>
  axiosInstance.get(`${SERVICES.AUDIENCE}/${organizationId}/recipients/${recipientId}/engagement`)

const recipientFeed = (organizationId, recipientId) =>
  axiosInstance.get(`${SERVICES.AUDIENCE}/${organizationId}/recipients/${recipientId}/feed`)

const recipientNotes = (organizationId, recipientId, body) =>
  axiosInstance.post(`${SERVICES.AUDIENCE}/${organizationId}/recipients/${recipientId}/Notes`, body)

const recipientDeleteNote = (organizationId, recipientId, noteKey) =>
  axiosInstance.delete(
    `${SERVICES.AUDIENCE}/${organizationId}/recipients/${recipientId}/Notes/${noteKey}`
  )

const recipientPathNote = (organizationId, recipientId, noteKey, body) =>
  axiosInstance.patch(
    `${SERVICES.AUDIENCE}/${organizationId}/recipients/${recipientId}/Notes/${noteKey}`,
    body
  )

const recipientTags = (organizationId, recipientId, method, body) =>
  axiosInstance({
    url: `${SERVICES.AUDIENCE}/${organizationId}/recipients/${recipientId}/Tags`,
    method: method,
    data: body
  })
const recipientStatus = (organizationId, recipientId, body) =>
  axiosInstance.patch(
    `${SERVICES.AUDIENCE}/${organizationId}/recipients/${recipientId}/status`,
    body
  )
const recipientSubscriptions = (organizationId, recipientId, body) =>
  axiosInstance.patch(
    `${SERVICES.AUDIENCE}/${organizationId}/recipients/${recipientId}/subscriptions`,
    body
  )
const patchRecipientId = (organizationId, recipientId, body) =>
  axiosInstance.patch(`${SERVICES.AUDIENCE}/${organizationId}/recipients/${recipientId}`, body)

const getAudienceEvolution = organizationId =>
  axiosInstance.get(`${SERVICES.AUDIENCE}/${organizationId}/evolution`)

const getAudienceScore = organizationId =>
  axiosInstance.get(`${SERVICES.AUDIENCE}/${organizationId}/score`)

export default {
  // CREATE and IMPORT AUDIENCE
  hasAudience,
  hasAudienceInProcess,
  sendFile,
  sendTable,
  sendForImport,

  // TYPES
  fieldtypes,
  defaultFieldDataTypes,

  // AUDIENCE
  audience,
  audienceSchema,
  audienceDelete,
  exportAudience,
  downloadExport,

  // HISTORY
  importHistory,
  exportHistory,

  //SEGMENTS
  getClientSegment,
  getOperators,
  getClientOverview,
  createSegment,
  exportSegment,
  downloadExportSegment,
  updateSegment,
  getTotalAudience,
  getSegment,

  //SEGMENTS LIST
  getClientSegmentsList,
  deleteClientSegment,

  //SEGMENT DETAILS
  getSegmentContactList,

  //AUDIENCE DETAIL
  getRecipientId,
  patchRecipientId,
  recipientStatus,
  recipientSubscriptions,
  recipientNotes,
  getRecipientEngagement,
  recipientTags,
  recipientFeed,
  recipientDeleteNote,
  recipientPathNote,

  //Custom Fields
  patchFieldtypes,

  getIndicatorsAudience,

  getAudienceEvolution,
  getAudienceScore
}
